<template>
  <div class="attachments">
    <div class="level mb-10">
      <div class="level-left">
        <h3 class="title is-6 mb-0">{{title}}</h3>
      </div>
      <div class="level-right" v-if="editable">
        <div class="control mr-10" v-if="types">
          <select v-model="type" class="select is-small attachment-type-selector">
            <option v-for="type in types" :value="type.id">
              {{type.name}}
            </option>
          </select>
        </div>
        <b-loading :is-full-page="true" :active.sync="upload"></b-loading>
        <div class="control">
          <b-upload v-model="file" @input="fileUpload">
            <a class="button is-primary is-small">
              <b-icon icon="file-outline" size="is-small"></b-icon>
              <span>{{ $t('interface.uploadFile') }}</span>
            </a>
          </b-upload>
        </div>
      </div>
    </div>
    <div class="files mt-15" v-if="data.length > 0">
      <div v-for="attachment in data"
           class="file-tile"
           :class="{
           large: size === 'large'
         }">
        <div :class="`file-type-ico ${attachment.extension}`"></div>
        <div class="name">
          <a target="_blank" :href="attachment.file">
            <span class="file-name-container" :title="attachment.name">{{attachment.name}}</span>
            <b-icon class="icon" icon="download" size="is-small"></b-icon>
          </a>
          <a class="delete-ico" @click="remove(attachment.id)" v-if="editable">
            <b-icon class="icon" icon="delete" size="is-small"></b-icon>
          </a>
        </div>

        <div class="date">{{attachment.created_at | localedDateWithYear}}</div>
      </div>
    </div>
    <div class="has-text-grey-light mb-25 mt-15" v-else>
      {{ $t('interface.noFiles') }}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      size: String,
      required: false,
      default: 'normal',
      data: Array,
      upload: Boolean,
      title: {
        type: String,
        required: true
      },
      editable: Boolean,
      types: {
        type: null,
        required: false,
        default: false
      }
    },
    data() {
      return {
        file: null,
        type: this.types ? this.types[0].id : null
      }
    },
    methods: {
      fileUpload() {
        if (!this.types) {
          this.$emit('file-upload', {file: this.file, type: null})
        } else if (this.type !== null) {
          this.$emit('file-upload', {file: this.file, type: this.type})
        } else {
          this.$toast.open({message: this.$t('errors.chooseFileType'), type: 'is-danger'})
        }
      },
      remove(id) {
        this.$dialog.confirm({
          message: this.$t('interface.fileDeletingAcceptation'),
          cancelText: this.$t('interface.cancel'),
          confirmText: 'OK',
          type: 'is-danger',
          onConfirm: () => this.$emit('remove-file', id)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title.is-6 {
    margin-bottom: 15px;
  }

  .attachment-type-selector {
    max-width: 185px;
  }

  .file-tile {
    display: inline-block;
    width: 50%;
    position: relative;
    padding-right: 10px;
    padding-left: 36px;
    margin-bottom: 18px;

    &.large {
      width: 33.33%;
    }

    .file-type-ico {
      width: 36px;
      position: absolute;
      left: -4px;
      top: 4px;
    }

    .date {
      font-size: 13px;
      line-height: 12px;
      margin-top: 3px;
      color: #888;
    }

    .name {
      display: inline-block;
      margin-top: 3px;
      width: 100%;

      .file-name-container {
        display: inline-block;
        max-width: calc(100% - 50px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: top;
        margin-right: 4px;
      }

      .icon {
        position: relative;
        top: 1px;
      }

      .delete-ico {
        display: inline-block;
        vertical-align: top;
        position: relative;
        top: -1px;
      }
    }
  }
</style>